module.exports = __webpack_public_path__ + "media/legacy/components/MainSection/edgy-up-1baa71cabc518dc43c747c197e84fa58.png";